import styled from 'styled-components';

import {ms} from '../../../../../styles';
import {View} from '../../../../../uikit/View';

export const Container = styled(View)`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${ms(62)} ${ms(72)};

  iframe {
    width: 100%;
    height: 100%;
    border: none;
    background-color: #fff;
  }

  @media (max-width: 768px) {
    padding: ${ms(52)} ${ms(24)};
  }
`;

export const LoadingSpinnerContainer = styled(View)`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
